import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  background-color: ${(props) => props.theme.colors.brand4.dark};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: fixed;
  z-index: 8;
  top: 0;
  left: 0;
  padding: 30px 0 60px 0;
  gap: 24px;
  
  @media (max-height: 568px) {
    padding: 5px 0 10px 0;
  }

  label {
    @media (min-width: 768px) {
      padding-top: 12vh;
    }
    @media (min-width: 1280px) {
      padding-top: 20vh;
    }

    &::after {
      content: "Escolha uma marca";
      font-size: 1rem;
      color: ${(props) => props.theme.colors.typography1.pure};

      @media (min-width: 768px) {
        font-size: 2rem;
        line-height: 30px;
      }
    }
  }

  .title {
    margin-top: 4px !important;

    @media (min-width: 768px) {
      text-align: left !important;
      margin-left: 14% !important;
      width: 100%;
      font-size: 1.5rem !important;
    }
  }

`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 60%;
  justify-content: space-evenly;

  @media (min-width: 768px) {
    justify-content: center;
  }

  > button {
    background-color: transparent;
    color: ${(props) => props.theme.colors.typography1.pure};
    border: none;
    display: flex;
    align-items: center;
    margin: 8px 12px;

    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
      margin: 1px 12px;
    }
  }

  span {
    padding: 15px;
    font-size: 0.7rem;
    
    @media (min-width: 768px) {
      font-size: 0.8rem;
    }
  }

  img {
    width: 80px;
    height: 80px;
  }
`;
